import axios from 'axios';

const api = '/api/configurations';

export const getConfigs = () => {
  return axios.get(`${api}?cacheBuster=${new Date().getTime()}`);
};

export const saveConfigs = data => {
  return axios.post(`${api}?cacheBuster=${new Date().getTime()}`, data);
};

export const sendTestEmail = () => {
  return axios.get(`${api}/test-email?cacheBuster=${new Date().getTime()}`);
};

export const getConfiguration = key => {
  return axios.get(`${api}/byKey/${key}?cacheBuster=${new Date().getTime()}`);
};

export const saveConfiguration = (key, data) => {
  return axios.post(`${api}/byKey/${key}?cacheBuster=${new Date().getTime()}`, data, {
    headers: {
      'Content-Type': 'text/plain',
    },
  });
};
